import { ReactElement, useEffect, useState } from 'react';
import { Space, TableProps } from 'antd';
import { CheckboxValueType } from 'antd/es/checkbox/Group';
import { Table } from 'common/components/antd/Table/Table';
import { ColumnSettingsButton } from './components/ColumnSettingsButton/ColumnSettingsButton';
import { ColumnSettingsPopover } from './components/ColumnSettingsPopover/ColumnSettingsPopover';
import { FilterButton } from './components/FilterButton/FilterButton';
import { FilterPopover } from './components/FilterPopover/FilterPopover';
import { SHeader } from './ExtendedTable.style';

export const ExtendedTable = <RecordType extends object = any>({
  columns,
  filtersElem,
  submitFilter,
  hideColumnsBtn,
  hideFiltersBtn,
  ...restProps
}: TableProps<RecordType> & {
  filtersElem?: React.ReactNode;
  submitFilter?: boolean;
  hideColumnsBtn?: boolean;
  hideFiltersBtn?: boolean;
}): ReactElement => {
  const [visibleColumnIndexes, setVisibleColumnIndexes] = useState<CheckboxValueType[]>(
    (columns || []).map((_, index) => index),
  );
  const mergedColumns = (columns || []).filter((_, index) => visibleColumnIndexes.includes(index));
  const [showFilters, setShowFilters] = useState<boolean>(false);

  useEffect(() => {
    setShowFilters(submitFilter ? !submitFilter : showFilters);
  }, [submitFilter]);

  return (
    <div>
      {!(hideFiltersBtn && hideColumnsBtn) && (
        <SHeader>
          {!hideFiltersBtn && (
            <Space size={16}>
              <FilterPopover open={showFilters} content={filtersElem}>
                <FilterButton
                  shown={showFilters}
                  onClick={(): void => {
                    setShowFilters((prev) => !prev);
                  }}
                />
              </FilterPopover>
            </Space>
          )}
          {!hideColumnsBtn && (
            <ColumnSettingsPopover
              setVisibleColumnIndexes={setVisibleColumnIndexes}
              visibleColumnIndexes={visibleColumnIndexes}
              columns={columns || []}
            >
              <ColumnSettingsButton />
            </ColumnSettingsPopover>
          )}
        </SHeader>
      )}
      <Table columns={mergedColumns} {...restProps} />
    </div>
  );
};
